import { Typography } from "@packages/ds";
import styled from "styled-components";

export const RefreshSectionRoot = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--ebony);
  padding-left: 40px;
  padding-right: 16px;
  padding-top: 0;
`;

export const RefreshRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CustomTypographyTitle = styled(Typography.Title)`
  color: var(--snow);
  margin: 8px 0;
`;

export const CustomTypographyLabel = styled(Typography.Label)`
  color: var(--periwinkle-grey);
`;
